import React from "react";

import styled from "styled-components";

import { AutomationCommandProps } from "../types/automation";
import { SetFocusPayload } from "../types/payloads";

const SetFocusCommand: React.FC<AutomationCommandProps> = (props) => {
  const payload = props.command.payload as SetFocusPayload;

  return (
    <RootContainer>
      {payload?.title ? (
        <div>
          Set Focus to <strong>{payload.title}</strong>
        </div>
      ) : (
        <div>No Group By Information Specified</div>
      )}
    </RootContainer>
  );
};

export default SetFocusCommand;

const RootContainer = styled.div``;
